// @ts-check
import React, { useState } from "react";
import { forgotPassword } from "../../../redux/auth/actions";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import parsePhoneNumber from "libphonenumber-js";
import { Toaster } from "../../../utils/toaster";
import { APP_CONST } from "../../../config/const";
import { Modal } from "react-bootstrap";

/**
 *
 * @param {string} mobileNumber
 * @returns {{phone:string;countryCode:string}}
 */
const getParsedMobileNumber = (mobileNumber) => {
  const phoneNumber = parsePhoneNumber("+" + mobileNumber);

  if (!phoneNumber) {
    return {
      phone: "",
      countryCode: "",
    };
  }

  return {
    phone: phoneNumber?.nationalNumber,
    countryCode: phoneNumber?.countryCallingCode,
  };
};

const ForgotPasswords = ({ show, handleClose, handleModalShow }) => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  /**
   *
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!mobileNumber || mobileNumber === "") {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "Please enter mobile number");
      return;
    }
    setIsLoading(true);
    const response = await forgotPassword(getParsedMobileNumber(mobileNumber));
    setIsLoading(false);
    if (response) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "OTP sent");
      handleClose();
      handleModalShow(APP_CONST.AUTH_MODAL.RESET_PASSWORD);
    }
  };

  return (
    <Modal
      show={show}
      id="loginModal"
      className={"steps-canvas login-modal LoginModal"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
    >
      <Modal.Header
        closeButton
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
        closeVariant="white"
      ></Modal.Header>
      <Modal.Body>
        <div className={"login-section ForgotPasswordSection"}>
          <div className="Login-rightPart LoginNewDesign ForgotPassword">
            <Modal.Title>Forgot Password</Modal.Title>
            <div className="form-steps">
              <Form onSubmit={handleSubmit}>
                <Form.Group
                  className="position-relative  mb-4"
                  controlId="formBasicPassword"
                >
                  {/* <label>Phone Num</label> */}
                  <PhoneInput
                    country={"in"}
                    countryCodeEditable={false}
                    inputProps={{
                      name: "phone",
                      required: true,
                    }}
                    // onlyCountries={["in"]}
                    inputStyle={{
                      width: "100%",
                    }}
                    onChange={(phone) => {
                      setMobileNumber(phone);
                    }}
                  />
                </Form.Group>
                <Button
                  variant="primary mb-4"
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? "Loading.." : "Get OTP"}
                </Button>
              </Form>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ForgotPasswords;
